import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { PropertyService } from "../../services/property.services";
import { ActivatedRoute, Router } from "@angular/router";
import { SiilaIndexReportComponent } from "../static-pages";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "../../../../environments/environment";
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";
import { BreakpointObserver } from "@angular/cdk/layout";
import { SendNotificationComponent } from "../send-notification/send-notification.component";
import { generate, Observable, of, Subject, zip } from "rxjs";
import { AccountService, NewsService } from "../../../core";
import { NewsSearch } from "../../models/news-search.model";
import { NewsNavigateService } from "../../services/news.navigate.service";
import { SiilaTranslationService } from "../../../core/services/siila-translation.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexYAxis,
  ApexTooltip,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexTheme
} from "ng-apexcharts";
import { apexObj, apexObj2 } from "../../utils/params";
import { DatePipe } from "@angular/common";
import { I18nService } from "../../services";
import { MetaService } from "@ngx-meta/core";
import { FeaturedListingService } from "../../../core/services/featured-listing.service";
import { DeviceRegistrationService } from "../../../core/services/device-registration.service";
import { ProductService } from "../../../core/services/products.service";
import { ProductItem } from "../../../core/models/products.model";
import { color } from "html2canvas/dist/types/css/types/color";
import { DomSanitizer } from "@angular/platform-browser";
import { CommonGenericService } from "../../services/common.service";
import * as e from "express";
import {
  PropertyFeaturesService,
  PropertyOptions
} from "../../services/property-features.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LocalNumberPipeSpot } from "../../pipes/number-pipe";
import { HttpClient } from "@angular/common/http";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap
} from "rxjs/operators";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  title: ApexTitleSubtitle;
  labels: string[];
  stroke: any;
  dataLabels: any;
  fill: ApexFill;
  tooltip: ApexTooltip;
  theme: ApexTheme;
  colors: string[];
  events: any;
  responsive: any;
};

const monthNamesMap = {
  Jan: "Ene",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Abr",
  May: "May",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Ago",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dic"
};

export type TenantAction = {
  id: number;
  buildingTenant: any;
  actionType: number;
  dateAction: Date;
  tenantNameEdit: string;
  marketSegment: any;
  newTenantArea: any;
  askingRentMXN: number;
  askingRentUSD: number;
};

export type BuildingFeatureDetails = {
  featureName: string;
  featureDisplayName: string;
  featureSelectedOptions: string[];
};

export type PropertyFeaturesIds = {
  id: number;
  buildingId: number;
  featureId: number;
  selectedOptions: number[];
  active: boolean;
};

export type UnitMix = {
  floorPlan: string;
  numberOfUnits: number;
  avgArea: number;
  cqAvgMonthlyRent: number;
  monthlyrentsm: number;
  cqAvgMonthlyRentFurnished: number;
  monthlyrentsmf: number;
  detailsName: string;
};

export type MarketComment = {
  marketConfigId: number;
  comment: string;
  createdDate: Date;
  user: any;
};

export type MarketSegment = {
  id: number;
  name: string;
};

@Component({
  selector: "app-stats-dashboard",
  templateUrl: "./stats-dashboard.component.html",
  styleUrls: ["./stats-dashboard.component.scss"]
})
export class StatsDashboardComponent implements OnInit {
  dialogRef: any;
  id;
  isMobile: boolean = false;
  listingCards;
  property: any;
  photos: any[] = [];
  registry: any[] = [];
  plan: any[] = [];
  documents: any[] = [];
  buildings = [];
  propertiesComparable;
  platformId = environment.platformId;
  owners;
  developers;
  isAdmin = false;
  user: any;
  isResearchAdmin = false;
  isResearchLead = false;
  isResearchCountryManager = false;
  articles: NewsSearch;
  browserLang;
  showDetail = false;
  vacantAreaList: any = [];
  countBomaArea = false;
  marketRentList: any = [];
  occupancies: any = [];
  researchData: any = [];
  marketSegments: Array<MarketSegment> = [];
  historicOccupancies: any = [];
  countBomaMarket = [];
  industryPercentagesList: any = [];
  public chartOptions: Partial<ChartOptions>;
  public chartOptionsOccupancy: Partial<ChartOptions>;
  public chartOptionsPie: Partial<ChartOptions>;
  tenantAreas: [] = [];
  showShortDesciption = true;
  hiddeMoreFeatures;
  pointOfInterest = [];
  vacancySpot: any;
  selectedMarketConfig: any;
  typeBar = 1;
  marketCardList = [];
  marketImgCard: string[];
  products: ProductItem[];
  currentCode: string;
  listFeatures: any = [];
  listManager: any = [];
  unitsMix: any = [];
  marketConfigs: any = [];
  researchUsers: any = [];
  propertyNameFilter: string = "";
  buildingIdFilter: string = "";
  filteredData: any[] = [];
  leadResearchUsers: any = [];
  unitMixColVisibility: Map<string, boolean> = new Map();
  featuresOptions: BuildingFeatureDetails[] = [];
  validateMarketRent = [];
  changesFilter: string = "ALL";
  statusFilter: string = "ALL";
  showPhone = false;
  showEmail = false;
  rentRolls = [];
  currentFundsBuilding = [];
  neighborhoodDescription;
  customPropertyFeatures: PropertyOptions[] = [];
  keyFactsMultifamilyOpts: PropertyOptions[] = [];
  areasMeasurementsOpts: PropertyOptions[] = [];
  complexInformation = null;
  countPlannedDate = 0;
  buildingOccupancies: any;
  selectedTenant: any;
  currentAction: any;
  editMoveOutDate: Date;
  editAskingRentMXN: number;
  editAskingRentUSD: number;
  newTenantArea: number = 0;
  splitSuite: boolean = false;

  editTenantWithIndustry: any;
  selectedMarketSegment: MarketSegment;
  editTenantName: string = "";
  editIndustryName: string = "";
  autocompleteResults: Array<any> = [];
  isLoading: boolean = false;
  showAddTenants: boolean = false;
  addTenantMode: boolean = false;
  newComment: string = "";
  showNewCommentBox: boolean = false;
  comments: MarketComment[];
  rejectionMode: boolean = false;
  private searchSubject = new Subject<string>();
  confirmationDialogMode: number = 0;

  statusList: any[] = [
    { value: "ALL", viewValue: "All" },
    { value: "INITIAL", viewValue: this.i18.get("tenants-property.initial") },
    {
      value: "REJECTED BY LEAD",
      viewValue: this.i18.get("tenants-property.rejectedByLead")
    },
    {
      value: "SUBMITTED",
      viewValue: this.i18.get("tenants-property.submitted")
    },
    {
      value: "APPROVED BY LEAD",
      viewValue: this.i18.get("tenants-property.approvedByLead")
    },
    {
      value: "WAITING FOR MARKET SUBMISSION",
      viewValue: this.i18.get("tenants-property.waitingForMarketSubmission")
    },
    {
      value: "MARKET SUBMITTED",
      viewValue: this.i18.get("tenants-property.marketSubmitted")
    },
    {
      value: "APPROVED BY MGMT",
      viewValue: this.i18.get("tenants-property.approvedByMgmt")
    }
  ];

  siteVisitFilter: string = "ALL";
  unresolvedCommentsFilter: string = "ALL";
  feeMissingFilter: string = "ALL";

  @ViewChild("chartModal", { static: false }) chartModal!: ElementRef;

  @ViewChild("confirmationDialog", { static: false })
  confirmationDialog!: TemplateRef<any>;

  @ViewChild("commentsDialog", { static: false }) commentsDialog!: TemplateRef<
    any
  >;

  showSpinner: boolean = false;

  get isBomaMarket() {
    return this.countBomaMarket && this.countBomaMarket.length > 0;
  }

  constructor(
    private propertyService: PropertyService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private siilaTranslationService: SiilaTranslationService,
    private datePipe: DatePipe,
    private i18: I18nService,
    private deviceRegistration: DeviceRegistrationService,
    private accountService: AccountService,
    private modalService: NgbModal,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {
    this.breakpointObserver
      .observe(["(max-width: 450px)"])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    this.chartOptions = apexObj as ChartOptions;
    this.chartOptionsOccupancy = apexObj2 as ChartOptions;
    this.currentCode = environment.platformId;
  }

  async ngOnInit() {
    if (this.validateSesion()) {
      this.route.params.subscribe(params => {
        zip(
          this.propertyService.getMarketResearchConfig(),
          this.propertyService.getResearchUsers(),
          this.propertyService.getLeadResearchUsers()
        ).subscribe(async resp => {
          this.marketConfigs = resp[0];
          this.researchUsers = resp[1];
          this.leadResearchUsers = resp[2];
          if (params.marketId) {
            this.selectedMarketConfig = this.marketConfigs.find(
              config => config.marketId === parseInt(params.marketId)
            );
          } else {
            this.selectedMarketConfig = this.marketConfigs[0];
          }
          this.comments = this.selectedMarketConfig.comments;
          if (this.selectedMarketConfig) {
            this.propertyService
              .getResearchDataByMarket(this.selectedMarketConfig.marketId)
              .then((resp1: any) => {
                this.showDetail = true;
                this.researchData = resp1;
                // filter this.statusList by looping through this.researchData and checking if the status is in the list
                this.statusList = this.statusList.filter(status =>
                  this.researchData.some(
                    data => data.buildingMarketTenantStatus === status.value
                  )
                );
                this.filteredData = this.researchData;
              });
          }
        });
      });
    } else {
      this.router.navigateByUrl("/");
    }
  }

  selectMarketConfigByMarketId(marketId: number) {
    this.selectedMarketConfig = this.marketConfigs.find(
      config => config.marketId === marketId
    );
    this.comments = this.selectedMarketConfig.comments;
  }

  reloadMarketData() {
    this.propertyService
      .getResearchDataByMarket(this.selectedMarketConfig.marketId)
      .then((resp1: any) => {
        this.showDetail = true;
        this.researchData = resp1;
        this.filteredData = this.researchData;
        this.propertyService.getMarketResearchConfig().then((resp: any) => {
          this.marketConfigs = resp;
          // select the market config that was selected before
          this.selectedMarketConfig = this.marketConfigs.find(
            config => config.marketId === this.selectedMarketConfig.marketId
          );
          this.comments = this.selectedMarketConfig.comments;
        });
      });
  }

  getConfigStatusLabel() {
    if (
      this.comments.length > 0 &&
      this.getConfigStatus().toUpperCase() == "WAITING FOR MARKET SUBMISSION"
    ) {
      return "REJECTED BY MGMT";
    }

    return this.getStatusLabel(this.getConfigStatus().toUpperCase());
  }

  getConfigStatus() {
    if (this.selectedMarketConfig) {
      return this.selectedMarketConfig.status.toUpperCase();
    }

    return "";
  }

  getStatusLabelByCode(code: string) {
    switch (code) {
      case "0":
        return this.i18.get("tenants-property.initial");
      case "1":
        return this.i18.get("tenants-property.submitted");
      case "2":
        return this.i18.get("tenants-property.approvedByLead");
      case "3":
        return this.i18.get("tenants-property.rejectedByLead");
    }
  }

  filterResearchData() {
    this.filteredData = this.researchData.filter(data => {
      const matchesPropertyName = this.getBuildingNameWithType(data)
        .toLowerCase()
        .includes(this.propertyNameFilter.toLowerCase());

      const matchesBuildingId =
        this.buildingIdFilter === "" ||
        data.buildingId.toString().includes(this.buildingIdFilter);

      const matchesChangesFilter =
        this.changesFilter === "ALL" ||
        (this.changesFilter === "YES" && data.hasChanges) ||
        (this.changesFilter === "NO" && !data.hasChanges);

      const matchesSiteVisitFilter =
        this.siteVisitFilter === "ALL" ||
        (this.siteVisitFilter === "YES" && data.siteVisit) ||
        (this.siteVisitFilter === "NO" && !data.siteVisit);

      const matchesUnresolvedCommentsFilter =
        this.unresolvedCommentsFilter === "ALL" ||
        (this.unresolvedCommentsFilter === "YES" && data.unresolvedComments) ||
        (this.unresolvedCommentsFilter === "NO" && !data.unresolvedComments);

      const matchesFeeMissingFilter =
        this.feeMissingFilter === "ALL" ||
        (this.feeMissingFilter === "YES" && data.feeMissing) ||
        (this.feeMissingFilter === "NO" && !data.feeMissing);

      const matchesStatusFilter =
        this.statusFilter === "ALL" ||
        this.statusFilter === data.buildingMarketTenantStatus.toUpperCase();

      return (
        matchesPropertyName &&
        matchesBuildingId &&
        matchesChangesFilter &&
        matchesSiteVisitFilter &&
        matchesUnresolvedCommentsFilter &&
        matchesFeeMissingFilter &&
        matchesStatusFilter
      );
    });
  }

  formatDates(date: Date | string): string {
    if (!date) return "";

    var formatDate =
      this.i18.getCurrentLanguage() === "pt-br" ? "dd/MM/yyyy" : "MM/dd/yyyy";

    return this.datePipe.transform(date, formatDate) || "";
  }

  onAddTenant() {
    this.addTenantMode = true;
  }

  onBackToSearchTenant() {
    this.addTenantMode = false;
    this.showAddTenants = false;
    this.editTenantWithIndustry = null;
    this.editIndustryName = "";
    this.editTenantName = "";
  }

  translateLabel(name) {
    return this.i18.getTranslation(name);
  }

  setQuarter(date) {
    let [year, month, day] = date.split("-").map(Number);
    let input = new Date(year, month - 1, day);
    let quarter = Math.floor((input.getMonth() + 3) / 3);
    return `${quarter} ${
      this.browserLang === "pt" || this.browserLang === "es" ? "T" : "Q"
    } ${this.datePipe.transform(input, "yyyy")}`;
  }

  async validateSesion() {
    if (localStorage.getItem("token")) {
      return this.setUser();
    } else {
      let isValidToken = this.deviceRegistration.validateCookie();

      if (isValidToken) {
        let account = await this.accountService.getAccount();
        localStorage.setItem("user", JSON.stringify(account));
        return this.setUser();
      }
    }

    return false;
  }

  getStatusList() {
    return this.statusList;
  }

  getStatusLabel(status: string) {
    switch (status) {
      case "INITIAL":
        return this.i18.get("tenants-property.initial");
      case "REJECTED BY LEAD":
        return this.i18.get("tenants-property.rejectedByLead");
      case "SUBMITTED":
        return this.i18.get("tenants-property.submitted");
      case "APPROVED BY LEAD":
        return this.i18.get("tenants-property.approvedByLead");
      case "WAITING FOR MARKET SUBMISSION":
        return this.i18.get("tenants-property.waitingForMarketSubmission");
      case "MARKET SUBMITTED":
        return this.i18.get("tenants-property.marketSubmitted");
      case "APPROVED BY MGMT":
        return this.i18.get("tenants-property.approvedByMgmt");
      case "REJECTED BY MGMT":
        return this.i18.get("tenants-property.rejectedByMgmt");
    }
  }

  setUser() {
    let user = JSON.parse(localStorage.getItem("user"));
    this.user = user;
    this.isAdmin = user?.roles?.includes("ROLE_ADMIN");
    this.isResearchAdmin =
      user?.roles?.includes("ROLE_COUNTRY_MANAGER") ||
      user?.roles?.includes("ROLE_RESEARCH_LEAD");

    this.isResearchLead = user?.roles?.includes("ROLE_RESEARCH_LEAD");

    this.isResearchCountryManager = user?.roles?.includes(
      "ROLE_COUNTRY_MANAGER"
    );
    if (
      !user?.roles?.includes("ROLE_COUNTRY_MANAGER") &&
      !user?.roles?.includes("ROLE_RESEARCH_LEAD") &&
      !user?.roles?.includes("ROLE_RESEARCH")
    ) {
      this.snackBar.open("You don't have access to Research section", "Close", {
        duration: 3000, // Duration in milliseconds
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ["custom-snackbar"]
      });
      this.router.navigateByUrl("/");
      return false;
    }
    return true;
  }

  getSubmitButtonLabel() {
    switch (this.getConfigStatus()) {
      case "INITIAL":
        return this.i18.get("tenants-property.submitForLeadApproval");
      case "WAITING FOR MARKET SUBMISSION":
        return this.i18.get("tenants-property.submitForMgmtApproval");
      case "MARKET SUBMITTED":
        return this.i18.get("tenants-property.marketSubmitted");
      case "APPROVED BY MGMT":
        return this.i18.get("tenants-property.approvedByMgmt");
      case "REJECTED BY MGMT":
        return this.i18.get("tenants-property.rejectedByMgmt");
    }

    return "";
  }

  getApproveButtonLabel() {
    switch (this.getConfigStatus()) {
      case "INITIAL":
        return "SUBMIT FOR MGMT APPROVAL";
      case "WAITING FOR MARKET SUBMISSION":
        if (this.comments.length > 0) {
          return "REJECTED BY MGMT";
        }
        return "SUBMIT FOR MGMT APPROVAL";
      case "MARKET SUBMITTED":
        return "APPROVE MARKET";
      case "APPROVED BY MGMT":
        return "APPROVED BY MGMT";
      case "REJECTED BY MGMT":
        return "REJECTED BY MGMT";
    }

    return "";
  }

  openCommentsDialog(): void {
    this.rejectionMode = false;
    const dialogRef = this.dialog.open(this.commentsDialog);

    dialogRef.afterClosed().subscribe(result => {});
  }

  openRejectionDialog(): void {
    this.rejectionMode = true;
    const dialogRef = this.dialog.open(this.commentsDialog);

    dialogRef.afterClosed().subscribe(result => {});
  }

  submitOrApprove(): void {
    switch (this.confirmationDialogMode) {
      case 1:
        this.submitMarket();
        break;
      case 2:
        this.approveMarket();
        break;
    }
    this.dialog.closeAll();
  }

  submitMarket(): void {
    this.propertyService
      .submitMarketForApproval(this.selectedMarketConfig.marketConfigId)
      .then(resp => {
        this.snackBar.open("Changes submitted for approval!", "Close", {
          duration: 3000, // Duration in milliseconds
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-snackbar"]
        });
        this.reloadMarketData();
      })
      .catch(err => {
        this.snackBar.open(
          this.i18.get("tenants-property.errorSubmittingChanges"),
          "Close",
          {
            duration: 10000,
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ["custom-snackbar"]
          }
        );
      });
  }

  approveMarket(): void {
    this.propertyService
      .approveMarket(this.selectedMarketConfig.marketConfigId)
      .then(resp => {
        this.snackBar.open("Changes submitted for approval!", "Close", {
          duration: 3000, // Duration in milliseconds
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-snackbar"]
        });
        this.reloadMarketData();
      });
  }

  openTenantsOwners() {
    window.open(
      `${environment.serverURL}/#!/building/${this.id}/tenants-detail`,
      "blank"
    );
  }

  validateTrnaslate(text) {
    return this.siilaTranslationService.getTranslation(text);
  }

  isMX() {
    return this.platformId && this.platformId == "mx";
  }

  openChartPopup(content: any, mode: string) {
    if (mode == "edit") {
      setTimeout(() => {
        this.selectedTenant.checkboxEdit = true;
      }, 10);
    }

    if (mode == "moveOut") {
      setTimeout(() => {
        this.selectedTenant.checkboxMoveOut = true;
      }, 10);
    }

    if (mode == "moveIn") {
      setTimeout(() => {
        this.selectedTenant.checkboxMoveIn = true;
      }, 10);
    }

    this.modalService.open(content, {
      centered: true,
      backdrop: false,
      keyboard: false
    });
  }

  isFutureDate(date) {
    if (date) {
      const currentDate = new Date();
      const parsedDate = new Date(date + "T00:00:00");
      if (parsedDate > currentDate) {
        this.countPlannedDate++;
      }
      return parsedDate > currentDate ? this.formatDate(date) : "";
    }
    return "";
  }

  isPastDate(date) {
    if (date) {
      const currentDate = new Date();
      const parsedDate = new Date(date + "T00:00:00");
      return parsedDate > currentDate ? "" : this.formatDate(date);
    } else {
      return "";
    }
  }

  formatDate(value) {
    if (value != "") {
      const date = new Date(value + "T00:00:00");
      const month = date.toLocaleString("en", { month: "short" });
      const year = date.getFullYear();

      return this.browserLang === "es"
        ? `${monthNamesMap[month]} ${year}`
        : `${month} ${year}`;
    }
    return value;
  }

  translateStatus(status: string): string {
    if (status === "Active") {
      return "Activo";
    } else if (status === "Inactive") {
      return "Inactivo";
    }
  }

  onInputChange(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.searchSubject.next(input);
  }

  fetchAutocompleteResults(query: string): Observable<any[]> {
    const apiUrl = `https://your-api.com/search?query=${query}`;
    return this.http.get<any[]>(apiUrl);
  }

  onSelectOption(option: any): void {
    this.editTenantWithIndustry = option;
    this.editTenantName = option.tenantName;
    this.editIndustryName = option.industryName;
    this.autocompleteResults = []; // Clear the autocomplete dropdown
  }

  resetModalValues() {
    this.editTenantWithIndustry = null;
    this.editIndustryName = "";
    this.editTenantName = "";

    this.editMoveOutDate = null;
    this.editAskingRentMXN = null;
    this.editAskingRentUSD = null;

    this.autocompleteResults = [];
    this.isLoading = false;
    this.newTenantArea = null;
    this.splitSuite = false;

    this.selectedMarketSegment = null;
    this.showAddTenants = false;
    this.addTenantMode = false;
  }

  discardChanges() {
    if (this.currentAction == "edit") {
      this.selectedTenant.checkboxEdit = false;
      this.selectedTenant.action = null;
      this.resetModalValues();
      this.modalService.dismissAll();
    }

    if (this.currentAction == "moveOut") {
      this.selectedTenant.checkboxMoveOut = false;
      this.selectedTenant.action = null;
      this.resetModalValues();
      this.modalService.dismissAll();
    }
  }

  onCheckboxClick(event: Event, tenantRow: any, action): void {
    this.selectedTenant = tenantRow;
    this.currentAction = action;
    this.resetModalValues();
    if (action == "edit") {
      if (
        this.selectedTenant.action &&
        this.selectedTenant.action.actionType == 0
      ) {
        // Load this action
        this.editTenantName = this.selectedTenant.action.tenantNameEdit;
        if (this.selectedTenant.action.marketSegment) {
          this.editIndustryName = this.selectedTenant.action.marketSegment.name;
        }
      } else {
        //this.resetModalValues();
      }
    }

    if (action == "moveOut") {
      this.editTenantName = this.selectedTenant.tenantName;
      if (
        this.selectedTenant.action &&
        this.selectedTenant.action.actionType == 1
      ) {
        this.editMoveOutDate = this.selectedTenant.action.dateAction;
        this.editAskingRentMXN = this.selectedTenant.action.askingRentPerAreaMXN;
        this.editAskingRentUSD = this.selectedTenant.action.askingRentPerAreaUSD;
      } else {
        //this.resetModalValues();
      }
    }

    if (action == "moveIn") {
      if (
        this.selectedTenant.action &&
        this.selectedTenant.action.actionType == 2
      ) {
        this.editTenantName = this.selectedTenant.action.tenantNameEdit;
        this.editMoveOutDate = this.selectedTenant.action.dateAction;
        if (this.selectedTenant.action.marketSegment) {
          this.editIndustryName = this.selectedTenant.action.marketSegment.name;
        }
        this.splitSuite = this.selectedTenant.action.splitSuite;
        this.newTenantArea = this.selectedTenant.action.newTenantArea
          ? this.selectedTenant.action.newTenantArea
          : 0;
      }
    }

    this.openChartPopup(this.chartModal, action);
  }

  saveChanges() {
    if (this.currentAction == "edit" || this.currentAction == "moveIn") {
      if (
        !this.addTenantMode &&
        !this.editTenantWithIndustry &&
        this.selectedTenant.action &&
        this.selectedTenant.action.marketSegment
      ) {
        this.editTenantWithIndustry = {};
        this.editTenantWithIndustry.industryName = this.selectedTenant.action.marketSegment.name;
        this.editTenantWithIndustry.industryId = this.selectedTenant.action.marketSegment.id;
      } else {
        if (!this.editTenantWithIndustry && this.selectedMarketSegment) {
          this.editTenantWithIndustry = {};
          this.editTenantWithIndustry.industryName = this.selectedMarketSegment.name;
          this.editTenantWithIndustry.industryId = this.selectedMarketSegment.id;
        }
      }
    }

    if (this.currentAction == "edit") {
      this.selectedTenant.action = {
        actionType: 0,
        tenantNameEdit: this.editTenantName,
        marketSegment: {
          name: this.editTenantWithIndustry.industryName,
          id: this.editTenantWithIndustry.industryId
        },
        buildingTenant: {
          id: this.selectedTenant.id
        },
        dateAction: new Date().toISOString()
      };
    }

    if (this.currentAction == "moveOut") {
      this.selectedTenant.action = {
        actionType: 1,
        dateAction: this.editMoveOutDate,
        askingRentPerAreaMXN: this.editAskingRentMXN,
        askingRentPerAreaUSD: this.editAskingRentUSD,
        buildingTenant: {
          id: this.selectedTenant.id
        }
      };
    }

    if (this.currentAction == "moveIn") {
      this.selectedTenant.action = {
        actionType: 2,
        tenantNameEdit: this.editTenantName,
        marketSegment: {
          name: this.editTenantWithIndustry.industryName,
          id: this.editTenantWithIndustry.industryId
        },
        dateAction: this.editMoveOutDate,
        buildingTenant: {
          id: this.selectedTenant.id
        }
      };
      if (this.splitSuite) {
        this.selectedTenant.action.newTenantArea = this.newTenantArea;
        this.selectedTenant.action.splitSuite = true;
      }
    }

    this.modalService.dismissAll();
  }

  updateCheckboxValues(tenantsLastQuarter) {
    tenantsLastQuarter.forEach(tenant => {
      if (tenant.action && tenant.action.actionType == 0) {
        tenant.checkboxEdit = true;
      }
      if (tenant.action && tenant.action.actionType == 1) {
        tenant.checkboxMoveOut = true;
      }
      if (tenant.action && tenant.action.actionType == 2) {
        tenant.checkboxMoveIn = true;
      }
    });
  }

  closeModal() {
    this.snackBar.open("Closing modal!", "Close", {
      duration: 1000, // Duration in milliseconds
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: ["custom-snackbar"]
    });
    if (!this.selectedTenant.action) {
      setTimeout(() => {
        this.selectedTenant.checkboxMoveIn = false;
        this.selectedTenant.checkboxEdit = false;
        this.selectedTenant.checkboxMoveOut = false;
      }, 10);
    }
    this.modalService.dismissAll();
  }

  getBuildingTenantChangesURL(buildingId) {
    return `${
      environment.applicationURL
    }/property/${buildingId}/tenants/lang/${this.i18.getCurrentLanguage()}`;
  }

  getBuildingNameWithType(building) {
    let type =
      building.buildingTypeId == 1001
        ? this.i18.get("global.justIndustrial")
        : this.i18.get("global.justOffice");
    return this.isMX()
      ? `${building.buildingName}`
      : `${building.buildingName} - ${type}`;
  }

  getBuildingDetailURL(buildingId) {
    return `${
      environment.applicationURL
    }/property/${buildingId}/lang/${this.i18.getCurrentLanguage()}`;
  }

  validateSaveButton() {
    if (this.currentAction == "edit") {
      let validation1 = this.editTenantName && this.editIndustryName;
      let validation2 =
        this.addTenantMode && this.selectedMarketSegment && this.editTenantName;
      return validation1 || validation2;
    }

    if (this.currentAction == "moveOut") {
      return this.editMoveOutDate;
    }

    if (this.currentAction == "moveIn") {
      let validation1 =
        this.editTenantName && this.editIndustryName && this.editMoveOutDate;
      let validation2 = true;
      if (
        this.splitSuite &&
        (this.newTenantArea > this.selectedTenant.area - 1 ||
          this.newTenantArea <= 0)
      ) {
        validation2 = false;
      }
      return validation1 && validation2;
    }
  }

  saveData() {}

  discardAllChanges() {
    this.snackBar.open("Changes discarded. Previous state loaded", "Close", {
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: ["custom-snackbar"]
    });
    this.reloadTableData();
  }

  saveTenantsData(actions) {}

  getGLAFromTenants() {}

  getYearFromFirstTenant() {}

  getQuarterFromFirstTenant() {}

  getYearFromMarketConfig() {
    if (this.selectedMarketConfig.year) {
      let year = this.selectedMarketConfig.year;
      let quarter = this.selectedMarketConfig.quarter;
      if (quarter == 4) {
        year += 1;
      }
      return year;
    }
    return "";
  }

  getQuarterFromMarketConfig() {
    if (this.selectedMarketConfig.quarter) {
      let quarter = this.selectedMarketConfig.quarter;
      if (quarter == 4) {
        quarter = 1;
      } else {
        quarter += 1;
      }
      return quarter;
    }
    return "";
  }
  getModalTitle() {
    if (this.currentAction == "edit") {
      return "Edit Tenant";
    }
    if (this.currentAction == "moveOut") {
      return "Move Out Tenant";
    }
    if (this.currentAction == "moveIn") {
      return "Move In Tenant";
    }
  }

  cancelSubmission(): void {
    this.dialog.closeAll(); // Close the dialog
  }

  formatComment(comment: any): string {
    const date = this.formatDates(comment.createdDate);
    return `${date} - ${comment.comment} - by ${comment.user.firstName} ${comment.user.lastName} `;
  }

  addNewComment() {
    this.showNewCommentBox = false;
    this.comments.push({
      marketConfigId: this.selectedMarketConfig.marketConfigId,
      comment: this.newComment,
      createdDate: new Date(),
      user: {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName
      }
    });
    this.newComment = "";
  }

  showNewComment() {
    this.showNewCommentBox = true;
    this.newComment = "";
  }

  rejectAndSaveComments() {
    if (this.newComment && this.newComment.length > 3) {
      this.addNewComment();
    }

    this.propertyService
      .rejectAndAddMarketComments(
        this.selectedMarketConfig.marketConfigId,
        this.comments
      )
      .then(resp => {
        this.snackBar.open(
          "Status changed to INITIAL. Comments saved successfully!",
          "Close",
          {
            duration: 3000, // Duration in milliseconds
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ["custom-snackbar"]
          }
        );
        this.reloadMarketData();
        this.reloadTableData();
      });
    this.dialog.closeAll(); // Close the dialog
  }

  saveComments() {
    if (this.newComment && this.newComment.length > 3) {
      this.addNewComment();
    }
    this.propertyService
      .saveMarketComments(
        this.selectedMarketConfig.marketConfigId,
        this.comments
      )
      .then(resp => {
        this.snackBar.open("Comments saved successfully!", "Close", {
          duration: 3000, // Duration in milliseconds
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-snackbar"]
        });

        this.reloadTableData();
      });
    this.dialog.closeAll(); // Close the dialog
  }

  reloadTableData() {}

  onMarketChange(newSelection: any): void {
    this.researchData = null;
    this.openStatsPageByMarket(newSelection.marketId);
    /* this.propertyService
      .getResearchDataByMarket(this.selectedMarketConfig.marketId)
      .then((resp1: any) => {
        this.showDetail = true;
        this.researchData = resp1;
        this.filteredData = this.researchData;
        this.comments = this.selectedMarketConfig.comments;
      }); */
  }

  openStatsPageByMarket(marketId: number) {
    window.open(
      `${environment.applicationURL}/tenant-stats/market/${marketId}/lang/en`,
      "_blank"
    );
  }

  onResearcherSelected(selectedName: string, buildingId: number): void {
    const selectedResearcher = this.researchUsers.find(
      researcher => researcher.name === selectedName
    );

    // update building with new researcher
    this.propertyService
      .saveBuildingResearcher(buildingId, selectedResearcher.id)
      .then((resp: any) => {
        this.snackBar.open("Researcher updated", "Close", {
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-snackbar"]
        });
        /* this.propertyService.getResearchDataByMarket(this.selectedMarketConfig.marketId)
      .then((resp1: any) => {
        this.showDetail = true;
        this.researchData = resp1;
      }); */
      });
  }

  openConfirmationDialog(mode: number): void {
    this.confirmationDialogMode = mode;
    const dialogRef = this.dialog.open(this.confirmationDialog);

    dialogRef.afterClosed().subscribe(result => {});
  }

  getConfirmationDialogMessage() {
    if (this.confirmationDialogMode == 1) {
      return "Are you sure you want to submit these changes for approval?";
    }
    if (this.confirmationDialogMode == 2) {
      return "Are you sure you want to approve these changes?";
    }
    if (this.confirmationDialogMode == 3) {
      return "Are you sure you want to mark this property as removed from stats?";
    }
  }

  /**
   * Handles the site visit checkbox change event
   * Opens a confirmation dialog before applying the change
   */
  onSiteVisitChange(event: any, data: any): void {
    // Prevent the checkbox from changing state until confirmed
    event.source.checked = data.siteVisit;

    // Open the confirmation dialog using the existing component
    this.dialog.open(ConfirmationDialogComponent, {
      width: "400px",
      disableClose: true,
      autoFocus: true,
      panelClass: ["confirmation-dialog-custom"],
      data: {
        title: this.i18.get("tenants-property.confirmSiteVisitTitle"),
        message: this.i18.get("tenants-property.confirmSiteVisit"),
        confirmLabel: this.i18.get("detail.yes"),
        cancelLabel: this.i18.get("detail.no"),
        onConfirm: () => {
          data.siteVisit = !data.siteVisit;
          this.saveSiteVisitChange(data);
        }
      }
    });
  }

  downloadStatsCsvByMarket() {
    this.showSpinner = true;
    this.propertyService
      .downloadStatsCsvByMarket(this.selectedMarketConfig.marketId)
      .then(response => {
        const blob = new Blob([response], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element to trigger the download
        const a = document.createElement("a");
        a.href = url;
        a.download = `property_stats_market_id_${this.selectedMarketConfig.marketId}.csv`;
        document.body.appendChild(a);
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(error => {
        console.error("Error downloading CSV:", error);
        this.snackBar.open("Error downloading CSV file", "Close", {
          duration: 3000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["custom-snackbar"]
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  /**
   * Saves the site visit change to the backend
   * This is a placeholder method that you will need to implement
   */
  saveSiteVisitChange(data: any): void {
    // This is an empty method that you will implement later
    this.propertyService
      .changeSiteVisitStatus(data.buildingId, data.siteVisit)
      .then((resp: any) => {
        this.snackBar.open(
          this.i18.get("tenants-property.siteVisitChangedSuccessfully"),
          "Close",
          {
            duration: 3000,
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ["custom-snackbar"]
          }
        );
      });
  }
}
